module.exports = __webpack_public_path__ + "static/img/iconfont.7f1d117.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.svg?t=1555750596622
// module id = A4v9
// module chunks = 38